import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { CommonService } from "src/app/core/services/common.service";
import { dynamicParamterOptions } from "src/app/models/tdsp/tdsp-segments";
import { tdspConversionPixel } from "src/app/models/tdsp/tdsp-conversion-pixel";
import {
  countOccurrencesWithReduce,
  isEmpty,
} from "src/app/shared/utils/commonUtils";

@Component({
  selector: "app-tdsp-conversion-pixel-basic",
  templateUrl: "./tdsp-conversion-pixel-basic.component.html",
  styleUrl: "./tdsp-conversion-pixel-basic.component.scss",
})
export class TdspConversionPixelBasicComponent {
  @Input() stepInput: any;
  @Output() stepChange = new EventEmitter<any>();

  conversionPixel: tdspConversionPixel;
  parameterOptions: Array<any> = [];
  isEdit: boolean = false;
  isValid: boolean = false;
  globalParams: Object = {};

  dataSourceParameters: MatTableDataSource<any>;
  parameterColumns: string[] = ["type", "value", "cancel"];

  constructor(public commonService: CommonService) {
    this.conversionPixel = {
      name: "",
      dynamic_parameters: [],
      containsParam: false,
    };
  }

  ngOnInit() {
    this.conversionPixel = this.stepInput.conversionPixel;
    this.isEdit = this.stepInput.isEdit;
    this.globalParams = this.stepInput.globalParams;
    this.parameterOptions = dynamicParamterOptions;
    if (this.conversionPixel.dynamic_parameters.length != 0)
      this.refreshTable();
  }

  addDynamicParams() {
    let newType: string = "";

    const counts = countOccurrencesWithReduce(
      this.conversionPixel.dynamic_parameters,
      "type"
    );

    if ((counts["custom"] || 0) < 10) {
      newType = "custom";
    } else if ((counts["currency"] || 0) === 0) {
      newType = "currency";
    } else if ((counts["order_id"] || 0) === 0) {
      newType = "order_id";
    } else if ((counts["revenue"] || 0) === 0) {
      newType = "revenue";
    } else {
      return;
    }

    this.conversionPixel.dynamic_parameters.push({
      type: newType,
      value: "",
    });
    this.refreshTable();
  }

  refreshTable() {
    this.dataSourceParameters = new MatTableDataSource(
      this.conversionPixel.dynamic_parameters
    );
    this.validate();
  }

  containsParamChanged() {
    if (this.conversionPixel.containsParam) {
      this.addDynamicParams();
    } else {
      this.conversionPixel.dynamic_parameters.length = 0;
      this.refreshTable();
    }
  }

  removeParam(index: number) {
    this.conversionPixel.dynamic_parameters.splice(index, 1);
    this.refreshTable();
  }

  resetDynamicParamForm() {
    this.conversionPixel.dynamic_parameters.length = 0;
  }

  removeDynamicParams(index) {
    this.removeParam(index);
    if (this.conversionPixel.dynamic_parameters.length == 0) {
      this.conversionPixel.containsParam = false;
    }
    this.refreshTable();
  }

  isDynamicParamSelected(parameter) {
    if (parameter != "custom") {
      return (
        this.conversionPixel.dynamic_parameters.filter(
          (item) => item.type === parameter
        ).length == 1
      );
    } else {
      return (
        this.conversionPixel.dynamic_parameters.filter(
          (item) => item.type == "custom"
        ).length == 10
      );
    }
  }

  goHome() {
    this.commonService.goToLandingPage("tdsp/conversion-pixel", {
      ...this.globalParams,
    });
  }

  validate() {
    const { name, containsParam } = this.conversionPixel;
    this.isValid = (() => {
      if (isEmpty(name)) return false;

      if (containsParam) {
        const paramsValid = this.conversionPixel.dynamic_parameters.every(
          (parameter) => !isEmpty(parameter.type) && !isEmpty(parameter.value)
        );
        if (!paramsValid) return false;
      }

      return true;
    })();
  }

  proceed() {
    this.stepChange.emit({
      conversionPixel: this.conversionPixel,
    });
  }
}
